export default "/fonts/vendor/primeicons/primeicons.woff?449aa8c65cdc5c2a868645403b9ea4d3";